import styled from 'styled-components'
import { device } from 'Styled/variables'

export const TracksListContainer = styled.div`
  display: grid;
  // grid-row-gap: 50px;
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 1.5rem;

  @media ${device.smallScreen} {
    padding-left: 0rem;
    padding-right: 0rem;
    grid-row-gap: 0px;
    padding-bottom: 24px;
  }
`
